import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import type { BlotterCashEntry } from '@/store/blotter/types/BlotterCashEntry.ts';

type Props = {
  entry: BlotterCashEntry;
};

export const CashFieldSet = ({ entry }: Props) => {
  const isForward = entry.product === 'Outright' || entry.product === 'Ndf';
  const isSpot = entry.product === 'Spot';

  return (
    <div className="container-fluid">
      <div className="row">
        <BlotterDetailsField singleColumn labelI18NKey="blotter.tab.Cash.details.account" value={entry.account} />
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.clientWay"
          value={`${entry.way} ${entry.currencyPair}`}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.tradeDate"
          formatting="date"
          value={entry.execTime}
        />
      </div>
      <div className="row">
        {isSpot ? (
          <BlotterDetailsField
            singleColumn
            labelI18NKey="blotter.tab.Cash.details.spotDate"
            formatting="date"
            value={entry.spotDate}
          />
        ) : (
          <BlotterDetailsField
            singleColumn
            labelI18NKey="blotter.tab.Cash.details.forwardDate"
            formatting="date"
            value={entry.farDate}
          />
        )}
      </div>
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.dealtAmount"
          formatting="amount"
          value={entry.dealtAmount}
          currency={entry.dealtCurrency}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Cash.details.rate"
          formatting="rate"
          value={entry[isForward ? 'farRate' : 'spot']}
        />
      </div>
      {isForward && (
        <div className="row">
          <BlotterDetailsField labelI18NKey="blotter.tab.Cash.details.spotRate" formatting="rate" value={entry.spot} />
          <BlotterDetailsField
            labelI18NKey="blotter.tab.Cash.details.swapPoints"
            formatting="points"
            value={entry.points}
          />
        </div>
      )}
    </div>
  );
};
